"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.andThenForOption = void 0;
/**
 *  Returns `None` if the _input_ is `None`,
 *  otherwise calls _transformer_ with the value and returns the result.
 *
 *  XXX:
 *  Some languages call this operation flatmap.
 *  But we don't provide `flatMap()` as alias of this function
 *  to sort with other APIs.
 */
function andThenForOption(input, transformer) {
    if (!input.ok) {
        return input;
    }
    var result = transformer(input.val);
    return result;
}
exports.andThenForOption = andThenForOption;
